import HeaderTop from "./HeaderTop";
import Logo from "./Logo";
import Navbar from "./Navbar";
import HeaderRight from "./HeaderRight";
import MobileMenu from "./MobileMenu";
import HeaderCart from "./HeaderCart";
import ButtonOpenMobileMenu from "@/components/shared/buttons/ButtonOpenMobileMenu";
import HeaderSearch from "./HeaderSearch";
import HeaderRight2 from "./HeaderRight2";
import MobileMenuShow from "./MobileMenuShow";
import HeaderBottom from "./HeaderBottom";
import CategoriesMenu from '@/components/layout/headers/CategoriesMenu';
import HeaderWishlist from '@/components/layout/headers/HeaderWishlist';

export default function Header({ data, headerStyle, headerSize, navBg, categories, brands, catalogPage, filterMenu }) {
  return (
    <>
      <header
        className={`ltn__header-area  ${catalogPage ? 'catalog-header-wrapper' : ''} ${
          headerStyle === 2
            ? "ltn__header-4 ltn__header-6 ltn__header-transparent gradient-color-2"
            : headerStyle === 5
            ? "ltn__header-3 section-bg-6"
            : " ltn__header-transparent ltn__header-5  gradient-color-4"
        }`}
      >
        {/* <!-- ltn__header-top-area start --> */}
        {<HeaderTop data={data} headerStyle={headerStyle} headerSize={headerSize}/>}

        {/* <!-- ltn__header-top-area end --> */}

        {/* <!-- ltn__header-middle-area start --> */}
        <div
          className={`ltn__header-middle-area ${catalogPage ? 'catalog-header' : ''}
            ${headerStyle === 5 ? "" : " ltn__header-sticky"}
            ${headerStyle === 5 ? "" : headerStyle === 2 ? " ltn__sticky-bg-black" : " ltn__sticky-bg-white "}
            ${headerStyle === 5 ? "" : " ltn__logo-right-menu-option "}
            ${headerSize === "lg" ? " plr--9" : ""}`}
        >
          <div className={headerSize === "lg" ? "container-fluid" : "container"}>
            <div className="row">
              {/* logo */}
              <Logo
                  home={data?.home}
                  contact={data?.contact}
                  headerStyle={headerStyle}
                  navBg={navBg}
                  catalogPage={catalogPage}
              />
              {/* navbar */}
              {headerStyle === 5
                  ? <HeaderSearch contact={data?.contact}/>
                  : <Navbar
                      headerStyle={headerStyle}
                      navBg={navBg}
                      currency={data?.currentCurrency}
                  />
              }
              {/* header right */}
              {catalogPage ? (
                <>
                  {/*<ButtonOpenMobileMenu*/}
                  {/*    headerStyle={headerStyle}*/}
                  {/*/>*/}
                  <HeaderRight
                      headerStyle={headerStyle}
                      currency={data?.currentCurrency}
                  />
                </>
              ) : headerStyle === 2 ? (
                <ButtonOpenMobileMenu
                    headerStyle={headerStyle}
                    headerSize={headerSize}
                />
              ) : headerStyle === 5 ? (
                <HeaderRight2
                    headerStyle={headerStyle}
                    currency={data?.currentCurrency}
                />
              ) : (
                <HeaderRight
                    headerStyle={headerStyle}
                    currency={data?.currentCurrency}
                />
              )}
            </div>
          </div>
        </div>
        {/* <!-- ltn__header-bottom --> */}
        {headerStyle === 5 ? <HeaderBottom
            navBg={navBg}
            headerStyle={headerStyle}
            currency={data?.currentCurrency}
        /> : ""}
      </header>
      <HeaderCart currency={data?.currentCurrency}/>
      <HeaderWishlist />
      <MobileMenu
          home={data?.home}
          socialLinks={data?.socialLinks}
      />
      {
        filterMenu ? (
            <CategoriesMenu
                home={data?.home}
                socialLinks={data?.socialLinks}
                categories={categories}
                brands={brands}
            />
        ) : ''
      }
      <div className="ltn__utilize-overlay"></div>
      {headerStyle === 5 ? <MobileMenuShow /> : ""}
    </>
  );
};
